<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">Project toevoegen</h4>
        <small>{{ data.customer.name }}</small>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1" [disabled]="projectForm.saving">
        <i class="fal fa-times" aria-hidden="true"></i>
    </button>
</div>
<div mat-dialog-content class="modal-body">
    <app-customer-project-form
        #projectForm
        [customer]="data.customer"
        [types]="data.types"
        (saved)="dialogRef.close($event)" />
</div>
<div mat-dialog-actions class="modal-footer">
    <button mat-dialog-close [disabled]="projectForm.saving" color="primary" mat-button type="button">Annuleren</button>
    <div class="spacer"></div>
    <button
        (click)="projectForm.save()"
        [disabled]="projectForm.saving"
        color="primary"
        mat-raised-button
        type="button">
        Opslaan
    </button>
</div>
